module.exports = __webpack_public_path__ + "static/media/card.6c985702.png";